/* eslint-disable react-redux/no-unused-prop-types */
import React, { FC, PropsWithChildren } from 'react';

export interface TabProps {
    tabKey: string;
    title: React.ReactNode;
}

export const Tab: FC<PropsWithChildren<TabProps>> = ({ children }) => <>{children}</>;
